module.exports = __webpack_public_path__ + "static/img/login_logo2.90c0469.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/login_logo2.png
// module id = oiw8
// module chunks = 11